import { render } from "./ContentDetailPage.vue?vue&type=template&id=3754081f&ts=true"
import script from "./ContentDetailPage.vue?vue&type=script&lang=ts"
export * from "./ContentDetailPage.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__